module.exports = __webpack_public_path__ + "static/media/Шаркова Софья Михайловна Когда говорят музы, замолкают пушки Ленинградская область-2.png";